import ServiceHeader from "../../ServiceComponents/ServiceHeader";
import ServiceBody from "../../ServiceComponents/ServiceBody";

import { FaGreaterThan } from "react-icons/fa6";

import ServiceSection from "../../PageElements/HomePageElements/ServiceSection";
import ConsultSection from "../../PageElements/HomePageElements/ConsultSection";

export default function PortablePage() {
    return (
        <>
            <ServiceHeader
                childClass="PortableBGSection"
                breadcrumb={<>Services <FaGreaterThan size={15} /> Portable Services</>}
                title="Portable Services"
            />

            <ServiceBody
                serviceName="Portable Services"
            />
            <ServiceSection />
            <ConsultSection />
        </>
    )
}